// extracted by mini-css-extract-plugin
export default {"verifySsn":"JhBtLASqkGWgeUNwg82t"};